export default __webpack_public_path__ + "static/media/photoGreen.207e8487.svg";